import * as React from 'react';
import { TaxonomyTypeEnum } from '../../redux/TaxonomyVersionSlice';
import AfrReportsCore from '../AfrCore/AfrReportsCore';




const AfrReportsA = (props: any) => {

    return (
        <React.Fragment>
            <AfrReportsCore taxonomyType={TaxonomyTypeEnum.AFR} publicreports={false}/>
        </React.Fragment>
    );
}

export default AfrReportsA;